import OrderAddress from './orderAddress';
import OrderActions from './orderActions';
import useIsMobile from '../../hooks/useIsMobile';
import {useOrderStore} from '../../store/orderStore';
import React from 'react';
import {
    Card,
    CardContent,
    Typography,
    Icon,
    Icons,
    IconSizes,
} from '@toppy-webshop/toppy-design-system';
import {useI18nContext} from '../../i18n/i18n-react';

const OrderMenu = () => {
    const {LL} = useI18nContext();
    const {isMobile} = useIsMobile(576);
    const {order} = useOrderStore(state => state);

    return (
        <div>
            <Typography variant={'h5'} gutterBottom>
                <Icon
                    icon={Icons.CAR_SPEED}
                    size={IconSizes.L}
                    color={'yellow'}
                />
                &nbsp; Hier wordt er geleverd
            </Typography>
            <Card component={'nav'}>
                <CardContent>
                    <Typography variant={'h6'}>
                        {LL.order.shippingAddress.title()}
                    </Typography>
                    <OrderAddress address={order?.shippingAddress} />
                    {!isMobile && <OrderActions />}
                </CardContent>
            </Card>
        </div>
    );
};

export default OrderMenu;
